export default {"src":"/_next/static/media/wallet-classic-solid.4b44837a.svg","height":24,"width":24};